import { useLocation } from "wouter";
import { User, Scale, ShieldCheck, Handshake } from "lucide-react";
import { isUsuarioLoggedIn, getUsuarioNome } from "@/lib/usuario-auth";

/**
 * Barra de acesso GLOBAL — fica no topo de TODAS as páginas (renderizada
 * uma vez no App.tsx, acima das rotas). Três acessos sempre visíveis:
 *   • Login/Usuário  → /entrar (ou /painel se já logado)
 *   • Mediador       → /admin/validacao
 *   • Admin          → /admin
 *
 * Discreta de propósito (não compete com o header de conteúdo de cada página).
 * A pedido do Arthur: "os botões ficam sempre no cabeçalho, independente da
 * página que seja acessada — eles devem estar sempre lá".
 */
const LOGO_URL = "/acordei-logo-v2.png";

export default function HeaderGlobal() {
  const [location, navigate] = useLocation();
  const logado = isUsuarioLoggedIn();
  const nome = getUsuarioNome();
  const primeiroNome = (nome || "").split(" ")[0];

  // Nas áreas internas (admin/mediador e painel do contador) quem manda no
  // topo é o DashboardNav (Mediador/Admin/Sair). Esconde a barra global aqui
  // pra não duplicar os botões Mediador/Admin.
  if (location.startsWith("/admin") || location.startsWith("/painel")) return null;

  // Barra de acessos no topo de TODA página (não-sticky pra não brigar com o
  // header sticky de cada página). Sempre presente, a pedido do Arthur.
  return (
    <div className="relative z-30 w-full bg-[oklch(0.09_0.03_255)] border-b border-white/8">
      <div className="container">
        <div className="flex items-center justify-between h-10">
          <button
            onClick={() => navigate("/")}
            className="flex items-center gap-1.5 text-white/55 hover:text-white transition-colors"
          >
            <img src={LOGO_URL} alt="" className="w-4 h-4 object-contain opacity-80" />
            <span className="text-[11px] font-mono uppercase tracking-[0.18em]">Acessos</span>
          </button>

          <nav className="flex items-center gap-1.5">
            <button
              onClick={() => navigate(logado ? "/painel" : "/entrar")}
              className="flex items-center gap-1.5 px-2.5 py-1 rounded-lg border border-cyan-500/30 text-cyan-300 hover:bg-cyan-500/10 hover:border-cyan-400/50 text-xs font-semibold transition-all"
            >
              <User className="w-3.5 h-3.5" />
              <span className="hidden sm:inline">{logado ? (primeiroNome || "Meu painel") : "Entrar"}</span>
            </button>
            <button
              onClick={() => navigate("/captador")}
              className="flex items-center gap-1.5 px-2.5 py-1 rounded-lg border border-emerald-500/30 text-emerald-300 hover:bg-emerald-500/10 hover:border-emerald-400/50 text-xs font-semibold transition-all"
            >
              <Handshake className="w-3.5 h-3.5" />
              <span className="hidden sm:inline">Captador</span>
            </button>
            <button
              onClick={() => navigate("/admin/validacao")}
              className="flex items-center gap-1.5 px-2.5 py-1 rounded-lg border border-amber-500/30 text-amber-300 hover:bg-amber-500/10 hover:border-amber-400/50 text-xs font-semibold transition-all"
            >
              <Scale className="w-3.5 h-3.5" />
              <span className="hidden sm:inline">Mediador</span>
            </button>
            <button
              onClick={() => navigate("/admin")}
              className="flex items-center gap-1.5 px-2.5 py-1 rounded-lg border border-violet-500/30 text-violet-300 hover:bg-violet-500/10 hover:border-violet-400/50 text-xs font-semibold transition-all"
            >
              <ShieldCheck className="w-3.5 h-3.5" />
              <span className="hidden sm:inline">Admin</span>
            </button>
          </nav>
        </div>
      </div>
    </div>
  );
}
